import {
  ApiTokensCard,
  ChangePasswordForm,
  PageHeader,
  PasskeysCard,
  ProfileCard,
  TwoFactorCard,
} from "@nexys/user-management-web";

export const ProfilePage = () => (
  <div className="grid gap-6">
    <PageHeader
      title="Settings"
      description="Your account, sign-in methods and active sessions."
    />
    <div className="grid gap-6 lg:grid-cols-2">
      <ProfileCard />
      <ChangePasswordForm />
    </div>
    <div className="grid gap-6 lg:grid-cols-2">
      <PasskeysCard />
      <TwoFactorCard />
    </div>
    <ApiTokensCard />
  </div>
);
